<div class="lieferant-details-wrapper">
    <div *ngIf="futtermittellieferant" class="lieferant-preview">
        <div class="preview-row">
            <span class="preview-label">Futtermittellieferant</span>
            <span class="preview-value">{{ futtermittellieferant.bezeichnung || '-' }}</span>
        </div>
        <div class="preview-grid">
            <div class="preview-item">
                <span class="preview-label">Straße</span>
                <span class="preview-value">{{ futtermittellieferant.strasse || '-' }}</span>
            </div>
            <div class="preview-item">
                <span class="preview-label">PLZ / Ort</span>
                <span class="preview-value"
                    >{{ futtermittellieferant.plz || '-' }} {{ futtermittellieferant.ort || '' }}</span
                >
            </div>
            <div class="preview-item">
                <span class="preview-label">Telefon</span>
                <span class="preview-value">{{ futtermittellieferant.telefon || '-' }}</span>
            </div>
            <div class="preview-item">
                <span class="preview-label">QS-ID</span>
                <span class="preview-value">{{ futtermittellieferant.qs_id || '-' }}</span>
            </div>
        </div>
    </div>

    <div class="autocomplete-container">
        <kiene-autocomplete
            #nameAutocomplete
            (elementSelected)="selectedLieferant($event)"
            *ngIf="!futtermittellieferant?.futtermittellieferant_id"
            [displayFields]="['bezeichnung', 'ort']"
            [separator]="', '"
            [emitFreeText]="false"
            [createNewAllowed]="true"
            [createNewText]="'Lieferant anlegen'"
            (createNew)="createNewFuttermittellieferant($event)"
            [focus]="false"
            [genericApiUrl]="lieferantPath"
            [multiLine]="true"
            [panelWidth]="'min(420px, calc(100vw - 32px))'"
            [placeholder]="'Name'"
            [required]="true"
            [showClear]="false"
            [showLoadingIndicator]="true"
            class="full-width"
        >
        </kiene-autocomplete>
    </div>

    <div class="actions-row one-row">
        <button (click)="createOrUpdateFuttermittellieferant()" [disabled]="isLoading" color="accent" mat-flat-button>
            Speichern
        </button>
        <span class="spacer"></span>
        <ng-content select="[additional-actions]"></ng-content>
    </div>
</div>
